import { FC, FormEvent, useState } from 'react'

import { AuthenticateFailureReason } from '../../../../../redux/authentication/authenticationModels'
import { Button, Checkbox } from '../../../../components'
import { LinkButton } from '../../../../components/@buttons/LinkButton/LinkButton'
import { TextInput } from '../../../../compositions'
import { LoginFormData } from '../../../../entities/@forms/LoginForm/LoginForm'
import trans from '../../../../helpers/trans'
import { AuthRoutes } from '../../../../routes/subRoutes/authRoutes'
import { LoginFormErrors } from '../../validations'

import './ApiLogin.scss'

export interface ApiLoginProps {
    isLoading: boolean
    authenticateFailure: AuthenticateFailureReason | null
    formErrors: LoginFormErrors
    onSubmit: (data: LoginFormData) => void
    className?: string
}

export const ApiLogin: FC<ApiLoginProps> = ({
    isLoading,
    authenticateFailure,
    formErrors,
    onSubmit,
    className,
}) => {
    const [username, setUsername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [rememberMe, setRememberMe] = useState<boolean>(true)

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault()
        onSubmit({ username, password, rememberMe })
    }

    return (
        <form
            onSubmit={handleSubmit}
            className={`api-login ${className}`}
        >
            <hr className="api-login__separator" />

            <TextInput
                hideLabel
                required
                type="email"
                autoComplete="username"
                label={trans('common.email')}
                placeholder={trans('common.email')}
                error={formErrors.username}
                onChange={setUsername}
                className="api-login__input"
            />

            <TextInput
                hideLabel
                required
                type="password"
                autoComplete="password"
                label={trans('pages.login.password')}
                placeholder={trans('pages.login.password')}
                error={formErrors.password}
                onChange={setPassword}
                className="api-login__input"
            />

            <div className="api-login__reset-password-button-container">
                <Checkbox
                    label={trans('pages.login.remember')}
                    checked={rememberMe}
                    onChange={setRememberMe}
                    className="api-login__reset-password-checkbox"
                />

                <LinkButton
                    text={trans('pages.login.forgotPassword')}
                    to={`/${AuthRoutes.requestPasswordReset()}`}
                    className="api-login__reset-password-link"
                />
            </div>

            <div className="api-login__submit-button-container">
                {authenticateFailure && (
                    <p className="api-login__failed-message">
                        {authenticateFailure === AuthenticateFailureReason.invalidCredentials
                            ? trans('pages.login.loginFailure')
                            : trans('pages.login.loginUnknownFailure')}
                    </p>
                )}

                <Button
                    type="submit"
                    text={trans('pages.login.login')}
                    disabled={isLoading}
                    color="orange"
                    className="api-login__submit-button"
                />
            </div>
        </form>
    )
}
